import { ModalBusinessInformations } from '../components/pagesComponents/menuPage/modalBusinessInformations'
import { SaleCoupon } from '../components/pagesComponents/menuPage/saleCoupon'
import { CouponBanner } from '../components/pagesComponents/menuPage/couponBanner'
import { WholesaleLine } from '../components/pagesComponents/menuPage/WholesaleLine'
import { Header } from './Header'
import { MenuOne } from './MenuOne'
import { MenuTwo } from './MenuTwo'
import { MainLoader } from '../components/loaders/mainLoader'
import { ImSad } from 'react-icons/im'
import { useEffect, useState, useCallback } from 'react'
import { api } from '../services/api'
import { toast } from 'react-toastify'
import { useHistory} from 'react-router-dom'
import { ItemModalProvider } from './ItemModalContext'

import { Found } from './MenuOne/Card/style'

import { saveLogClube } from '../services/logClube'


export function Menu() {
  const nameBusiness = window.location.pathname.split('/')[2];
  const token = localStorage.getItem('@Inoveclube:token') ? localStorage.getItem('@Inoveclube:token') : ''
  const couponDescription = window.location.pathname.split('/')[3] === 'coupon' ? 
  window.location.pathname.split('/')[4] : undefined
  const isWholesale = localStorage.getItem('@Inoveclube:wholesale')
  const history = useHistory()

  const [saleCoupon, setSaleCoupon] = useState({})
  const [saleCouponVisible, setSaleCouponVisible] = useState(false)

  const [productsWithGroups, setProductsWithGroups] = useState([]);
  const [businessDatas, setBusinessDatas] = useState({});
  
  const [listProducts, setListProducts] = useState([]);        
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);

  const [loadProducts, setLoadProducts] = useState(false);
  const [loadingBusinessInformations ,setLoadingBusinessInformations] = useState(false)
  const [loadingFeeDelivery,setLoadingFeeDelivery] = useState(true);

  const [listBuying, setListBuying] = useState(() => JSON.parse(localStorage.getItem('@Inoveclube:listBuying' + nameBusiness)) || []);

  const [infoOpen, setInfoOpen] = useState(false)
  
  const [couponBanner, setCouponBanner] = useState(undefined)

  const [feeDelivery,setFeeDelivery] = useState('');
  
  const handleSearchChange = event => {
    setSearchTerm(event.target.value); 
  };

  const handleClearSearch = useCallback(() => {
    setSearchTerm("")
  }, [setSearchTerm]);

  const handleSetListBuying = useCallback((list) =>{
    setListBuying(list)
  },[])

  function getCouponBanner(data) {
    if(data.length === 0)
      return

    let minValue = Math.min(...data.map(({discountValue, typeDiscount}) => {
     return typeDiscount === 0 ? discountValue : 0 
    }))

    if(minValue === 0){
      setCouponBanner({discountValue: 0})
      return
    }

    let coupon = data.filter(coupon => {
      return coupon.active === true && coupon.discountValue === minValue
    })

   setCouponBanner(...coupon)
  }

  useEffect(() => {
    async function handleLogClube(){
      saveLogClube(localStorage.getItem('@Inoveclube:nameBusiness'),1,localStorage.getItem('@Inoveclube:token'))
    }
    handleLogClube();
  },[]);
  
  useEffect(() => {
    async function fetchData(){
      // console.log('token: '+localStorage.getItem('@Inoveclube:token'))
      await api.get(`/getBusiness/${nameBusiness}/${localStorage.getItem('@Inoveclube:token')}`)
      .then(response => { 
        if(Object.keys(response.data).length === 0){
          history.push('/profile')
          return
        }

        localStorage.setItem('@Inoveclube:idPixelGoogle', response.data.idPixelGoogle)

        localStorage.setItem('@Inoveclube:wholesale', response.data.userCanAccessMenu)
        
        setBusinessDatas(response.data)

          ///Calculando os fretes
          async function loadFeeDelivery(){
            //console.log(response.data)
            if(response.data.typeFeeDelivery.toUpperCase() === 'B'){
              try{
                const response = await api.get('/validateNeighborhood/' + localStorage.getItem('@Inoveclube:nameBusiness'), {
                  headers: {
                      token: localStorage.getItem('@Inoveclube:token')
                  }
                });
                if (response.data.status === true){
                  setFeeDelivery(response.data.feeDelivery)
                  setLoadingFeeDelivery(false);
                }
              }
              catch(error){
                //console.log(error)
                setFeeDelivery('');
                setLoadingFeeDelivery(false);
              }
            }
            else if(response.data.typeFeeDelivery.toUpperCase() === 'KM'){
              try{
                const response = await api.post('/getFeeDeliveryForKm',{
                  address:{
                    business: localStorage.getItem('@Inoveclube:nameBusiness'),
                    destiny: {}
                  },
                },
                {
                  headers: {
                      'Content-Type': 'application/json',
                      token: localStorage.getItem('@Inoveclube:token')
                  }
                });
                if(response.data.sucess === 0){
                  throw new Error(response.data.error)
                }
                setFeeDelivery(response.data.valueFeeDelivery);
                setLoadingFeeDelivery(false);
              }
              catch(error){
                //console.log(error)
                setFeeDelivery('');
                setLoadingFeeDelivery(false);
              }
            }
          }
          loadFeeDelivery()

        if(response.data.useOnlineOrder){
          localStorage.setItem('@Inoveclube:colorLabel', response.data.colorLabel)
          localStorage.setItem('@Inoveclube:colorButton', response.data.colorButton)
          localStorage.setItem('@Inoveclube:colorTransversalBar', response.data.colorTransversalBar)
          localStorage.setItem('@Inoveclube:colorBorderInput', response.data.colorBorderInput)
          localStorage.setItem('@Inoveclube:colorShadow', response.data.colorShadow)
          localStorage.setItem('@Inoveclube:colorButtonBottom', response.data.colorButtonBottom)
          localStorage.setItem('@Inoveclube:colorBgHeader', response.data.colorBgHeader)
          localStorage.setItem('@Inoveclube:neighborhoods', JSON.stringify(response.data.neighborhoods))
          localStorage.setItem('@Inoveclube:imageBusiness', response.data.linkProfile)

          async function fetchData(){
            try{
                await api.get(`/getCoupons/?business=${response.data.idBusiness}&getAll=0`, {
                    headers: {
                        token: localStorage.getItem('@Inoveclube:token')
                    }
                }).then(response => {
                  //console.log(response.data)
                  getCouponBanner(response.data)
                });  
      
            }catch(error){
               //console.log(error)
               toast.error('Erro interno, recarregue a página')
            }
          }
          fetchData();

        } 
         
        
        document.title = response.data.name.toLowerCase().replace(/(^|\s)\S/g, l => l.toUpperCase())
        document.getElementById("favicon").href = response.data.linkProfile
        localStorage.setItem('@Inoveclube:numberBusiness', response.data.phoneNumber)
        localStorage.setItem('@Inoveclube:idCity', response.data.idCity)
        localStorage.setItem('@Inoveclube:state', response.data.state)
        localStorage.setItem('@Inoveclube:street', `${response.data.street}, ${response.data.number}, ${response.data.neighborhood}`)
        localStorage.setItem('@Inoveclube:maps', 
          `https://www.google.com.br/maps/place/
          ${response.data.street},+
          ${response.data.number},+
          ${response.data.neighborhood},+
          ${response.data.city},+
          ${response.data.state}`
        )
        localStorage.setItem('@Inoveclube:socialMedias', JSON.stringify({
          whatsapp: response.data.whatsapp, 
          instagram: response.data.instagram, 
          facebook: response.data.facebook
        }))

        localStorage.setItem('@Inoveclube:openMon', response.data.openingTimeMon)
        localStorage.setItem('@Inoveclube:closeMon', response.data.closingTimeMon)
        localStorage.setItem('@Inoveclube:openTue', response.data.openingTimeTue)
        localStorage.setItem('@Inoveclube:closeTue', response.data.closingTimeTue)
        localStorage.setItem('@Inoveclube:openWed', response.data.openingTimeWed)
        localStorage.setItem('@Inoveclube:closeWed', response.data.closingTimeWed)
        localStorage.setItem('@Inoveclube:openThu', response.data.openingTimeThu)
        localStorage.setItem('@Inoveclube:closeThu', response.data.closingTimeThu)
        localStorage.setItem('@Inoveclube:openFri', response.data.openingTimeFri)
        localStorage.setItem('@Inoveclube:closeFri', response.data.closingTimeFri)
        localStorage.setItem('@Inoveclube:openSat', response.data.openingTimeSat)
        localStorage.setItem('@Inoveclube:closeSat', response.data.closingTimeSat)
        localStorage.setItem('@Inoveclube:openSun', response.data.openingTimeSun)
        localStorage.setItem('@Inoveclube:closeSun', response.data.closingTimeSun)
      })
      setLoadingBusinessInformations(true)
    }
    fetchData()
  }, [nameBusiness, history])
  

  useEffect(() => {
    let arrayProducts = [];
    productsWithGroups.map(element => (
      element.products.map(product => {
        return (
          arrayProducts.push(product.name),
          setListProducts(arrayProducts)
        )
      })
    ))
  }, [productsWithGroups])


  useEffect(() => {
      const results = listProducts.filter(product =>
        product.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setSearchResults(results);
  }, [listProducts, searchTerm]);


  useEffect(() =>{
    if(window.location.pathname.split('/')[3] !== undefined && 
      window.location.pathname.split('/')[3] !== '' &&
      window.location.pathname.split('/')[3] !== 'coupon'
    ){
      localStorage.setItem('@Inoveclube:type', window.location.pathname.split('/')[3])
      localStorage.setItem('@Inoveclube:typeNumber', window.location.pathname.split('/')[4]) 
      localStorage.setItem('@Inoveclube:onlyTableModality', true)
    }else{
      localStorage.removeItem('@Inoveclube:type')
      localStorage.removeItem('@Inoveclube:typeNumber') 
      localStorage.removeItem('@Inoveclube:onlyTableModality')
    }
    localStorage.setItem('@Inoveclube:nameBusiness', nameBusiness)
  }, [nameBusiness])

  useEffect(() => {
    async function fetchData(){
      await api.get(`/getProductsWithGroups/${nameBusiness}/${localStorage.getItem('@Inoveclube:type')}` )
      .then(response => setProductsWithGroups(response.data));
      setLoadProducts(true)
    }
    fetchData()
  }, [nameBusiness, token]);

 
  useEffect(() => {
    async function fetchData(){
      if(couponDescription === undefined || couponDescription === '')
        return

      await api.get(`/getCouponInfoWithDescription/${nameBusiness}/${couponDescription}`)
      .then(response => {
        setSaleCoupon(response.data)
        if(response.data.idCoupon !== undefined)
          setSaleCouponVisible(true)
      });
    }
    fetchData()
  }, [nameBusiness, couponDescription])

  

  if (searchResults.length === 0 && searchTerm.trim() !== "") {
      return (
        <>
            <ModalBusinessInformations 
              open={infoOpen}
              closeModal={setInfoOpen}
            />

            { isWholesale === 'true' && <WholesaleLine /> }

            <Header 
              searchTerm={searchTerm} 
              businessDatas={businessDatas}
              handleSearchChange={handleSearchChange}
              handleClearSearch={handleClearSearch}
              listBuying={listBuying}
              setInfoOpen={setInfoOpen}
            />
            {productsWithGroups.length > 0 ?
              <Found>
                Produto não encontrado
                <ImSad />
              </Found> : <></>}
        </>
      );
    }
    else {
      if(loadProducts && loadingBusinessInformations){
          return(
            <>
            {businessDatas.idBusiness !== undefined ? 
                <ItemModalProvider>
                    <ModalBusinessInformations 
                      open={infoOpen}
                      closeModal={setInfoOpen}
                    />

                    <SaleCoupon 
                        saleCouponVisible={saleCouponVisible} 
                        saleCoupon={saleCoupon}
                    /> 

                    <CouponBanner 
                      couponValue={couponBanner?.discountValue}
                      couponExistis={couponBanner !== undefined}
                    />
                    
                    {  isWholesale === 'true' && <WholesaleLine /> }

                    <Header 
                      searchTerm={searchTerm} 
                      businessDatas={businessDatas}
                      handleSearchChange={handleSearchChange}
                      handleClearSearch={handleClearSearch}
                      listBuying={listBuying}
                      setInfoOpen={setInfoOpen}
                      feeDelivery={feeDelivery}
                      loadingFeeDelivery={loadingFeeDelivery}
                    />

                    {productsWithGroups.length !== 0 ?
                      businessDatas.typeGroup === 0 ?
                        
                        <MenuOne 
                          productsWithGroups={productsWithGroups} 
                          searchTerm={searchTerm} 
                          businessDatas={businessDatas}
                          searchResults={searchResults}
                          listBuying={listBuying}
                          infoOpen={infoOpen}
                          couponBanner={couponBanner}
                          handleSetListBuying={handleSetListBuying}
                        /> 
                        :
                        <MenuTwo 
                          productsWithGroups={productsWithGroups} 
                          searchTerm={searchTerm} 
                          businessDatas={businessDatas}
                          searchResults={searchResults}
                          listBuying={listBuying}
                          infoOpen={infoOpen}
                          handleSetListBuying={handleSetListBuying}
                        />
                      
                      :
                      <div style={{ 
                          height: '70vh',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          flexDirection: 'column',
                          color: 'gray',
                          fontSize: '0.9rem'
                        }}>
                        <h1>nenhum</h1>
                        <h1 style={{marginBottom: '1rem'}}>produto listado</h1>
                        <ImSad style={{fontSize: '3rem'}}/>
                      </div>
                    }
                </ItemModalProvider>

              :

              <h1 style={{color: "var(--colorButton)"}}>404 not found</h1>
            }
            </>
          )
      }else{
        return(<MainLoader title={'Buscando produtos'}/>)
      }
    }
}